import { Layer, GlobalContext } from '../../../../context/context';
import { emitGtfsFileDropped } from '../gtfsImportEvent';

interface GTFSImportProps {
    global: GlobalContext;
    editLayer: (layer: Layer, layerId: number) => void;
    setShouldFitBounds: (should: boolean) => void;
    setIsProcessingGTFS: (processing: boolean) => void;
    setGtfsError: (error: string | null) => void;
    setIsImportGTFSModalOpen: (open: boolean) => void;
}

export function handleGTFSImport({
    setGtfsError,
    setIsImportGTFSModalOpen
}: GTFSImportProps) {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.zip';
    
    input.onchange = (e) => {
        const file = (e.target as HTMLInputElement).files?.[0];
        if (!file) return;

        setGtfsError(null);
        setIsImportGTFSModalOpen(false);
        emitGtfsFileDropped(file);
    };

    // Trigger file selection dialog
    input.click();
} 
